
export default class Accordion {
	constructor(el) {
		this.element 	= el

		// TURNING THIS INTO AN ARRAY ENABLES US TO INDEX THROUGH IT
		this.accordions = [...this.element.querySelectorAll(".accordion") ];

		// THIS BINDS THE CLICKACCORDION METHOD TO THE "THIS" CONTEXT
		this.clickAccordion = this.clickAccordion.bind(this)
	}
  
	init() {

		const accordionItems = document.getElementsByClassName("accordion__item");
		if(accordionItems.length) {
			for (let i = 0; i < accordionItems.length; i++) {
				accordionItems[i].addEventListener("click", function () {
					this.classList.toggle("accordion__item--open");
				});
			}
		}

		// LISTEN FOR CLICKS ON EACH ACCORDION ELEMENT
		for (var i = 0; i < this.accordions.length; i++) {

			// THIS WAS NOT WORKING PREVIOUSLY BECAUSE I NEED TO BIND THE CLICK EVENT TO THE "THIS" CONTEXT.
			this.accordions[i].addEventListener('click', this.clickAccordion )

		}
	}
  
	clickAccordion(event) {

		const inx = this.accordions.indexOf(event.currentTarget)
		const accordion = this.accordions[inx]

		// CHANGE ATTRIBUTE OF CLICKED
		const button = accordion.querySelector('.accordion__tab');
		const region = accordion.querySelector('.accordion__region');
		if( accordion.classList.contains('accordion--open') ){
			button.setAttribute("aria-expanded", "false");
			region.setAttribute("aria-expanded", "false");
		} else {
			button.setAttribute("aria-expanded", "true");
			region.setAttribute("aria-expanded", "true");
		}

		// // OPEN CLICKED
		accordion.classList.toggle("accordion--open");

		// IF THIS IS THE ALTERNATIVE ACCORDION TYPE, CLOSE SIBLINGS
		if( accordion.parentElement.classList.contains('accordion-group') ){
			var siblings = accordion.parentElement.querySelectorAll('.accordion');
			this.closeSiblingAccordions(accordion,siblings);
		}

	}

	closeSiblingAccordions(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove("accordion--open");
				this.changeAccordionAttributes(siblings[i]);
			}
		}
	}

	changeAccordionAttributes(accordion){
		var button = accordion.querySelector('.accordion__tab');
		var region = accordion.querySelector('.accordion__region');

		// CHANGE ATTR
		button.setAttribute("aria-expanded", "false");
		region.setAttribute("aria-expanded", "false");
	}
  
	unmount() {
		for (var i = 0; i < this.accordions.length; i++) {

			// THIS WAS NOT WORKING PREVIOUSLY BECAUSE I NEED TO BIND THE CLICK EVENT TO THE "THIS" CONTEXT.
			this.accordions[i].removeEventListener('click', this.clickAccordion )

		}
	}
}
